import BaseAPI from "../base";
import { getStorageExpire, setStorageExpire } from "@/utils/utils";
import { CONFIG_STORAGE } from "@/constants/storage";

class Pd1Service extends BaseAPI {
  // 工单标签
  pd1WorkLabel(params) {
    return this.post({
      url: "/YuanHe/PD1/WorkLabel",
      data: params,
    });
  }

  // 权益详情
  quanyiDetail(params) {
    return this.post({
      url: "/YuanHe/PD1/QuanyiDetail",
      data: params,
    });
  }

  // 服务列表
  serviceList(params) {
    return this.post({
      url: "/YuanHe/PD1/ServiceList",
      data: params,
    });
  }

  // 文件上传记录
  fileRecord(params) {
    return this.post({
      url: "/YuanHe/PD1/FileRecord",
      data: params,
    });
  }

  // 文件上传
  fileUpload(params) {
    return this.post({
      url: "/YuanHe/PD1/FileUpload",
      data: params,
    });
  }

  // 文件移除
  fileRemove(params) {
    return this.post({
      url: "/YuanHe/PD1/FileRemove",
      data: params,
    });
  }

  // 获取审批进度
  progress(params) {
    return this.post({
      url: "/YuanHe/PD1/Progress",
      data: params,
    });
  }

  // 专家安排进度审批2
  editProgressExpertStep2(params) {
    return this.post({
      url: "/YuanHe/PD1/EditProgressExpertStep2",
      data: params,
    });
  }

  // 专家安排进度审批3
  editProgressExpertStep3(params) {
    return this.post({
      url: "/YuanHe/PD1/EditProgressExpertStep3",
      data: params,
    });
  }

  // 审批购药咨询步骤2
  progressGouyaoStep2(params) {
    return this.post({
      url: "/YuanHe/PD1/ProgressGouyaoStep2",
      data: params,
    });
  }

  // 审批用药补贴步骤2
  progressButieStep2(params) {
    return this.post({
      url: "/YuanHe/PD1/ProgressButieStep2",
      data: params,
    });
  }

  // 审批用药补贴步骤3
  progressButieStep3(params) {
    return this.post({
      url: "/YuanHe/PD1/ProgressButieStep3",
      data: params,
    });
  }

  // 药房列表
  drugstoreList(params) {
    return this.post({
      url: "/YuanHe/PD1/DrugstoreList",
      data: params,
    });
  }

  // 药品列表
  medicineList(params) {
    return this.post({
      url: "/YuanHe/PD1/MedicineList",
      data: params,
    });
  }

  // 药品编辑
  medicineEdit(params) {
    return this.post({
      url: "/YuanHe/PD1/MedicineEdit",
      data: params,
    });
  }

  // 计算垫付信息
  calculateAdvancePayment(params) {
    return this.post({
      url: "/YuanHe/PD1/CalculateAdvancePayment",
      data: params,
    });
  }

  // 审批用药补贴步骤2_垫付
  progressButieStep2_Dianfu(params) {
    return this.post({
      url: "/YuanHe/PD1/ProgressButieStep2_Dianfu",
      data: params,
    });
  }

  // 相关枚举
  pd1Enums() {
    return new Promise((resolve) => {
      let result = getStorageExpire(CONFIG_STORAGE.PD1_ENUM);

      if (result && result.version >= CONFIG_STORAGE.currentVersion)
        resolve(result);
      else {
        this.get({
          url: "/YuanHe/PD1/GetPD1EnumWork",
        }).then((res) => {
          console.log(res);
          Object.keys(res).forEach((key) => {
            const item = res[key];
            res[`${key}Arr`] = [];
            Object.keys(item).forEach((childKey) => {
              let value = childKey;
              if (isFinite(value)) {
                value = Number(value);
              }
              res[`${key}Arr`].push({
                value: Number(childKey),
                name: item[childKey],
              });
            });
          });
          setStorageExpire(
            CONFIG_STORAGE.PD1_ENUM,
            {
              ...res,
              version: CONFIG_STORAGE.currentVersion,
            },
            60 * 24
          );
          resolve(res);
        });
      }
    });
  }
}

export default new Pd1Service();
